import styled from "styled-components";

export const TextInputContainer = styled.div`
  width: 100%;
  position: relative;
  
`;
export const TextInputArea = styled.div`
  font-family: ${({ theme }) => theme.fonts.inter};
  background: ${({ theme }) => theme.settings.whiteColor};
  border: 1px solid #edeef3 !important;
  border-radius: 24px;
  padding: 32px 32px 20px;
  position: relative;
  transition: all 0.2s ease;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.secondary};
  box-shadow: 0px 30px 70px rgba(61, 41, 105, 0.08);
  &:focus-within {
    border-color:  ${({ theme }) => theme.settings.primary} !important;
    box-shadow: 0px 24px 70px rgba(61, 41, 105, 0.14);
  }
  &.customChatBox{
    box-shadow: none !important;
    border-radius: 12px;
    border: 1px solid  ${({ theme }) => theme.settings.borderColor};
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  border: none;
  outline: none;
  resize: none;
  font-family: ${({ theme }) => theme.fonts.inter} !important;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.secondary} !important;
  background: transparent;
  padding: 0;
  margin: 0;
  min-height: ${({ $minHeight }) => ($minHeight ? `${$minHeight}px` : "80px")};
  &:focus {
    outline: none;
  }
`;

export const BottomControls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  flex-wrap: wrap;
  gap: 12px;
`;

export const AttachmentSection = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  color: ${({ theme }) => theme.settings.primary} !important;
  font-size: 12px;
  font-family: ${({ theme }) => theme.fonts.inter} !important;
  font-weight: 500;
  transition: all 0.2s ease;
  background: ${({ theme }) => theme.settings.whiteColor};
  background-image: none !important;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  border-radius: 12px;
  padding: 10px 16px;
  box-shadow: none;
  &:hover {
    background: rgba(92, 58, 184, 0.04);
  }
`;

export const AttachmentIcon = styled.div`
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* border-radius: 50%;
  border: 1.5px solid #5c3ab8; */
  background: transparent;
  color: ${({ theme }) => theme.settings.primary} !important;
  img,
  svg {
    width: 14px;
    height: 14px;
    object-fit: contain;
    color: ${({ theme }) => theme.settings.primary} !important;
    filter: none !important;
  }
`;

export const RightControls = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SendButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${({ theme }) => theme.settings.primary} !important;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0px 15px 40px rgba(61, 41, 105, 0.25);
  &:hover {
    background: ${({ theme }) => theme.settings.primary} !important;
    opacity: 0.9;
    transform: scale(1.05);
    svg,
    img {
      filter: ${({ theme }) => theme.settings.imgFilterWhite} !important;
    }
  }
  &:active {
    transform: scale(0.95);
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    &:hover {
      transform: none;
    }
  }
`;

export const FilePreview = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${({ theme }) => theme.settings.whiteColor};
  border: 1px solid ${({ theme }) => theme.colors.borderColor};
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 12px;
`;

export const FileInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;

export const FileName = styled.div`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.secondary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FileSize = styled.div`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 11px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.lightText || '#999'};
`;

export const RemoveFileButton = styled.button`
  width: 24px;
  height: 24px;
  margin-right: 14px;
  border-radius: 50%;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.error || '#ff4d4f'};
  transition: all 0.2s ease;
  &:hover {
    background: ${({ theme }) => theme.colors.errorBg || '#fff2f0'};
  }
  &:active {
    transform: scale(0.9);
  }
  &:focus {
    outline: none;
  }
`;

export const UploadProgress = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 50px;
  height: 50px;
  position: relative;
  div{
    width: 100%;
    height: 100%;
    position: relative;
  }
  svg{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 6px;
  background: ${({ theme }) => theme.colors.borderColor || '#e0e0e0'};
  border-radius: 3px;
  overflow: hidden;
`;

export const ProgressFill = styled.div`
  height: 100%;
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 3px;
  transition: width 0.3s ease;
  width: ${({ $percent = 0 }) => `${Math.min(Math.max($percent, 0), 100)}%`};
`;

export const ProgressText = styled.div`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 11px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.lightText || '#999'};
  text-align: right;
`;

export const HiddenFileInput = styled.input`
  display: none;
`;
